module.exports = __webpack_public_path__ + "static/img/img-newusergiftmore.87c30fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/center/img-newusergiftmore.png
// module id = NjKz
// module chunks = 89